module.exports = __webpack_public_path__ + "static/media/4150.44863211.jpg";